var exports = {
  "Gt": "ChannelOriginIcon.module__frame___eml3Uk",
  "z5": "ChannelOriginIcon.module__cutout___eml3Uk",
  "qS": "ChannelOriginIcon.module__badge___eml3Uk",
  "Nw": "ChannelOriginIcon.module__badgeHighlighted___eml3Uk",
  "rF": "ChannelOriginIcon.module__badgeIcon___eml3Uk",
  "YQ": "ChannelOriginIcon.module__fallbackIcon___eml3Uk",
  "tR": "ChannelOriginIcon.module__fallbackIconHighlighted___eml3Uk",
};

module.exports = exports;
